// **React Imports
import React, { memo, useContext } from 'react'
import { Link as RouterLink } from 'react-router-dom'

// **MUI Imports
import { Box, Breadcrumbs, Link, Typography } from '@mui/material'
import { NavigateNext } from '@mui/icons-material'

// **Context Imports
import { SettingsContext } from '../../context/setting'

// **SCSS Imports
import './index.scss'

const BreadCrumbsBar = () => {
  // hooks
  const { settings } = useContext(SettingsContext)

  return (
    settings?.breadcrumbs?.length > 0 && (
      <Box className="breadcrumbs-bar">
        <Breadcrumbs separator={<NavigateNext sx={{fontSize:'16px'}}/>}>
          {settings?.breadcrumbs?.map((crumb, index) => {
            if (index === settings?.breadcrumbs?.length - 1) {
              return (
                <Typography className="breadcrumb-label" key={index}>
                  {crumb?.label}
                </Typography>
              )
            } else {
              return (
                <Link
                  component={RouterLink}
                  to={crumb?.link}
                  underline="hover"
                  color={'inherit'}
                  key={index}
                >
                  {crumb?.label}
                </Link>
              )
            }
          })}
        </Breadcrumbs>
      </Box>
    )
  )
}

export default memo(BreadCrumbsBar)
